import React, { memo } from "react";

const Album = memo(() => {
  return <div>Album</div>;
});

export default Album;
